import { datadogRum } from '@datadog/browser-rum';
import { initializeWithConsent } from '@fff-web/consent';
import env from '../config/env';

const initDatadogRum = () => {
  datadogRum.init({
    applicationId: env.DATADOG_RUM_APP_ID,
    clientToken: env.DATADOG_RUM_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'personal-survey',
    env: env.ENVIRONMENT,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording();
};

export const bootstrapDatadog = () => initializeWithConsent('C0002', initDatadogRum);
